module.exports = __webpack_public_path__ + "static/img/2718_phase_function_Paper_Points.e2874f4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/2718_phase_function_Paper_Points.png
// module id = Spsh
// module chunks = 0